import React from 'react';
import { motion } from 'framer-motion';
import { timelineEvents } from './data';
import TimelineNavigation from './TimelineNavigation';
import TimelineContent from './TimelineContent';
import TimelinePattern from './TimelinePattern';
import { useTimelineScroll } from './hooks/useTimelineScroll';

export default function Timeline() {
  const { currentIndex, handleIndexChange, isPaused } = useTimelineScroll();
  
  return (
    <section className="relative py-24 bg-[#FDF6E9] overflow-hidden">
      {/* Top Fade */}
      <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-white to-transparent z-10" />
      
      {/* Background Pattern */}
      <TimelinePattern />
      
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4 retro-text">
            Vores Historie
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            En rejse gennem tiden med Danmarks mest elskede pølsevogn
          </p>
        </motion.div>

        <TimelineNavigation 
          years={timelineEvents.map(event => event.year)}
          currentYear={timelineEvents[currentIndex].year}
          onYearClick={year => {
            const index = timelineEvents.findIndex(event => event.year === year);
            if (index !== -1) handleIndexChange(index);
          }}
        />

        <div className="mt-12">
          <TimelineContent 
            event={timelineEvents[currentIndex]}
            onNext={() => handleIndexChange((currentIndex + 1) % timelineEvents.length)}
            onPrev={() => handleIndexChange((currentIndex - 1 + timelineEvents.length) % timelineEvents.length)}
          />
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg
          className="w-full h-16 fill-white transform translate-y-1"
          viewBox="0 0 1440 48"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path d="M0,48 L1440,48 L1440,0 C960,24 480,24 0,0 L0,48 Z" />
        </svg>
      </div>
    </section>
  );
}